import {
  AvailabilitySlot,
  type AppointmentType,
  type AvailabilityExistsResponse,
} from '@dialogue/timekeeper'
import { PARTS_OF_DAY } from '../constants'
import { AvailabilitiesByDay } from 'APP/Store/AppointmentBooking/utils/availabilityMappers'
import { Moment as MomentType } from 'moment'
export type AvailabilitiesPerPartsOfDay = Record<PARTS_OF_DAY, AvailabilitySlot[]>

export enum TransformStrategy {
  BY_PART_OF_DAY = 'BY_PART_OF_DAY',
  BY_DAY = 'BY_DAY',
}

export interface TransformContext {
  timezone?: string
  endAt?: MomentType
}

export type TransformResultMap = {
  [TransformStrategy.BY_PART_OF_DAY]: AvailabilitiesPerPartsOfDay
  [TransformStrategy.BY_DAY]: AvailabilitiesByDay
}

export interface AvailabilitiesPerDate {
  times: AvailabilitiesPerPartsOfDay
  isLoading: boolean
  hasAvailabilities: boolean
}

export type FetchAvailabilitiesSuccessPayload = {
  times: AvailabilitiesPerPartsOfDay
  day: string
}

export interface FetchAvailabilitiesRequestPayload {
  bookingId: string
  day: string
  params: {
    start_at: string
  }
}

export type Availabilities = Record<string, AvailabilitiesPerDate>

/**
 * Per-day map (keyed by DATE_FORMAT) indicating whether any availability exists
 * for that day. Mirrors the `data` field of timekeeper's AvailabilityExistsResponse.
 */
export type AvailabilitiesExists = AvailabilityExistsResponse['data']

interface AnswerFlags {
  update_channel_state: boolean
}

interface SilkroadMessage {
  display?: string
  local_id?: string
  type: string
}

export interface SilkroadQuestion extends SilkroadMessage {
  created_at?: string // datetime
  unread?: boolean
  choices?: string[]
  resource_id?: string
  note?: string
  question_id?: string
  answer_flags?: AnswerFlags
}

export interface BookingProps {
  date_from: string
  date_until: string
  appointment_type: AppointmentType
  requested_slot: string
  is_rescheduling?: boolean
  appointment_id?: string
  booking_id?: string
}

export interface SilkroadSelfSchedulingQuestion extends SilkroadQuestion {
  microapp_props: BookingProps
}

export interface MattermostQuestion {
  props: BookingProps
}

export interface CreatedAppointment {
  is_booked: boolean
  service_id?: number
  provider_id?: number
  start_at?: string
  end_at?: string
  ih_practitioner_user_id?: number
  ih_service_id?: number
}

export interface Answer {
  display: string
  payload: CreatedAppointment
}

export interface SilkroadAnswer extends SilkroadMessage {
  device_id?: string
  payload: string[]
  question_type: string
  question_id?: string
  answer_flags: AnswerFlags
}

export interface MattermostAnswer {
  payload: string[]
  type: string
  display: string
  question_type: string
  answer_flags: AnswerFlags
}

export interface DateTimeInfo {
  start_date: string
  start_time: string
}

export type AnswerMessage = SilkroadAnswer | MattermostAnswer
